import { Colors, Row } from '@microfrontends/react-components'
import styled from 'styled-components'

export const IndustryCareerPathContainer = styled(Row)`
	margin-bottom: 30px;
`

export const Title = styled.p`
	margin-bottom: 0;
	font-family: 'Dela Gothic One';
	font-size: 18px;
	text-align: center;
`

export const Separate = styled.div`
	height: 1px;
	background-color: #d5d5d5;
`

export const ShowMoreBtn = styled.p`
	color: ${Colors.primary};
	transition: color 0.25s ease-in-out;
  cursor: pointer;
  width: fit-content;
  margin: 0 auto;
	&:hover {
		color: ${Colors.button};
	}
`
